import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './utils.intl.json';

export const useUtilsIntl = () => useIntlModule(messages);
